import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLoginPage() {
 const [email, setEmail] = useState("sales@ssk21.net");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("ssk_token", data.access_token);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-slate-200 p-8" data-testid="admin-login-card">
          <div className="w-12 h-12 bg-[#0F2747] text-white flex items-center justify-center mb-4"><Lock className="w-5 h-5" /></div>
          <div className="overline">SSK Enterprises</div>
          <h1 className="font-display text-2xl font-bold text-[#1E293B] mt-1">Admin Sign In</h1>
          <form onSubmit={submit} className="space-y-4 mt-6" data-testid="admin-login-form">
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-wider">Email</Label>
              <Input value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs uppercase tracking-wider">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
            </div>
            <button className="btn-primary w-full" disabled={loading} data-testid="login-submit">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
